import React from "react";
import ModalHeader from "@/customComponents/uiComponents/modal/ModalHeader.jsx";
import {PoliciesExtraDetailsContent} from "@/customComponents/globalComponents/policiesContent.jsx";

// Full Terms & Conditions content lives in globalComponents/policiesContent.jsx.
export {PoliciesExtraDetailsContent};

export function PoliciesExtraDetails({setStep, closeModal}) {
    return (
        <>
            <ModalHeader title="" extraClasses="" totalSteps={0} cancelButton={false} backStep="policiesListing" showBackButton={true} setStep={setStep} closeModal={closeModal}/>
            <PoliciesExtraDetailsContent/>
        </>
    );
}
export default PoliciesExtraDetails;
